import { Button } from "@/components/Base/Button";
import { StarIcon, StarOffIcon } from "lucide-react";

export interface CardStarProps {
  starred?: boolean;
  onStarToggle?: () => void;
}
export const CardStar = ({ starred, onStarToggle }: CardStarProps) => {
  return (
    <Button
      variant={starred ? "warning" : "ghost"}
      size="tinyIcon"
      onClick={onStarToggle}
    >
      {starred ? <StarIcon size={14} /> : <StarOffIcon size={14} />}
    </Button>
  );
};
